/* @flow */

import dispatcher from './dispatcher';
import StateStore from './store';
import { reducer } from './reducer';
import { effect } from './effect';

// To use 'dispatch' and 'waitFor' as independent methods we need to bind them with dispatcher context
const dispatch = dispatcher.dispatch.bind(dispatcher);
const waitFor = dispatcher.waitFor.bind(dispatcher);

export { StateStore, dispatcher, dispatch, reducer, effect, waitFor };
